import { ExternalLink } from '@ui-components/actions/ExternalLink'
import { TightSectionContent } from '@ui-components/containers/TightSectionContent'
import { IndentationText } from '@ui-components/decorative/IndentationText'
import { FlexColumnContainer } from '@ui-components/global/CommonStyling'
import { SPACE_MEDIUM } from '@ui-components/global/spacing'
import { IntroSection } from '@ui-components/layout/IntroSection'
import { BodyText, LabelText, LeadText } from '@ui-components/typography/Typography'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const IndentedCostsList = styled(IndentationText)`
  display: flex;
  flex-direction: column;
  gap: ${SPACE_MEDIUM};
`

export const MarketingSection = () => {
  const { formatMessage } = useIntl()
  const cost = 0
  return (
    <>
      <IntroSection
        title={formatMessage({ id: 'loan-offer-booking-step-footer-content-header' })}
        leadText={formatMessage({ id: 'loan-offer-booking-step-footer-content-lead-text-part1' })}
        headingLevel={2}
        showIntroSectionDivider={false}
      />
      <LeadText>{formatMessage({ id: 'loan-offer-booking-step-footer-content-lead-text-part2' })}</LeadText>
      <ExternalLink
        href={formatMessage({ id: 'loan-offer-booking-step-footer-content-calculator-href' })}
        key={'loan-offer-booking-step-footer-content-calculator-label'}
      >
        {formatMessage({ id: 'loan-offer-booking-step-footer-content-calculator-label' })}
      </ExternalLink>

      <TightSectionContent>
        <LabelText sizing="large">
          {formatMessage({ id: 'loan-offer-booking-step-footer-content-banking-services-heading' })}
        </LabelText>
        <BodyText tagName={'p'}>
          {formatMessage({ id: 'loan-offer-booking-step-footer-content-banking-services-content' })}
        </BodyText>
        <IndentedCostsList>
          <FlexColumnContainer>
            <LabelText>
              {formatMessage({ id: 'loan-offer-booking-step-footer-content-banking-services-accounts' })}
            </LabelText>
            <LabelText sizing="large">
              {cost} {formatMessage({ id: 'common-euros-per-month' })}
            </LabelText>
          </FlexColumnContainer>
          <FlexColumnContainer>
            <LabelText>
              {formatMessage({ id: 'loan-offer-booking-step-footer-content-banking-services-cards' })}
            </LabelText>
            <LabelText sizing="large">
              {cost} {formatMessage({ id: 'common-euros-per-month' })}
            </LabelText>
          </FlexColumnContainer>
          <FlexColumnContainer>
            <LabelText>
              {formatMessage({ id: 'loan-offer-booking-step-footer-content-banking-services-web-credentials' })}
            </LabelText>
            <LabelText sizing="large">
              {cost} {formatMessage({ id: 'common-euros-per-month' })}
            </LabelText>
          </FlexColumnContainer>
        </IndentedCostsList>
      </TightSectionContent>

      <TightSectionContent>
        <LabelText sizing="large">
          {formatMessage({ id: 'loan-offer-booking-step-footer-content-banking-easy-heading' })}
        </LabelText>
        <BodyText tagName={'p'}>
          {formatMessage({ id: 'loan-offer-booking-step-footer-content-banking-easy-content-part1' })}
        </BodyText>
        <BodyText tagName={'p'}>
          {formatMessage({ id: 'loan-offer-booking-step-footer-content-banking-easy-content-part2' })}
        </BodyText>
      </TightSectionContent>
    </>
  )
}
